// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"d18a1fe5","164":"77e3fb39","194":"279bc799","209":"24a23f8e","214":"62062f9e","236":"c0725187","367":"0caad692","628":"23deae63","648":"50caca27","796":"806936b4"}[chunkId] + ".chunk.css";
};